import React from 'react';
import { observer } from "mobx-react";
import { toJS } from 'mobx';
import { ProductInfoNs } from 'ReactApp/Types/ProductInfoNs';
import { showableCartInstance } from 'ReactApp/Ddd/Aggregates/ShowableCart';

type CartCountChangerV1Props = {
    cartInfo: ProductInfoNs.WithCartInfoInterface,
    cardIndex: number,
    isReadonlyMode: boolean,
    minValue?: number,
    maxValue?: number,
}

const CartCountChangerV1 = observer((props: CartCountChangerV1Props) => {

    const minValue = props.minValue !== undefined ? props.minValue : 1;
    const maxValue = props.maxValue !== undefined ? props.maxValue : 999;

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (
            (parseInt(e.currentTarget.value)) >= minValue
                &&
            (parseInt(e.currentTarget.value)) <= maxValue
        ) {
            let closeCartInfo = toJS(props.cartInfo);
            closeCartInfo.number = parseInt(e.currentTarget.value);
            showableCartInstance.changeCartInfoByIndex(
                props.cardIndex, closeCartInfo
            );
        }
    }

    const incrementHandler = (e: React.MouseEvent<HTMLInputElement>) => {
        if ((props.cartInfo.number as number) >= maxValue) {
            return;
        }
        let closeCartInfo = toJS(props.cartInfo);
        (closeCartInfo.number as number)++;
        showableCartInstance.changeCartInfoByIndex(
            props.cardIndex, closeCartInfo
        );
    }

    const decrementHandler = (e: React.MouseEvent<HTMLInputElement>) => {
        if ((props.cartInfo.number as number) <= minValue) {
            return;
        }
        let closeCartInfo = toJS(props.cartInfo);
        (closeCartInfo.number as number)--;
        showableCartInstance.changeCartInfoByIndex(
            props.cardIndex, closeCartInfo
        );
    }

    if (props.isReadonlyMode === true) {
        return (
            <p className="product-card-v6__count p-v1 p-v1_text-color-type-text">
                <span>Количество:&nbsp;</span>
                <span>{props.cartInfo.number || 1}</span>
            </p>
        );
    } else {
        return (
            <div className="count-changer-v1">
                <div className={`count-changer-v1__decrement${((props.cartInfo.number as number) <= minValue ? ' _disabled' : '')}`} onClick={decrementHandler}>
                    <svg className="icon-v1" width="9" height="9">
                        <use xlinkHref="/build/sprite.svg#minus-icon"></use>
                    </svg>
                </div>
                <div className="count-changer-v1__input">
                    <input className="" value={props.cartInfo.number || 1} onChange={changeHandler} />                    
                </div>
                <div className={`count-changer-v1__increment${((props.cartInfo.number as number) >= maxValue ? ' _disabled' : '')}`} onClick={incrementHandler}>
                    <svg className="icon-v1" width="9" height="9">
                        <use xlinkHref="/build/sprite.svg#plus-icon"></use>
                    </svg>
                </div>
            </div>
        );
    }


})

export default CartCountChangerV1;